import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { StatusEnum } from "../../../../../../commons/enums/status-enum";
import { manageFootballTeamService } from "../../../../../../commons";

interface IHostedCompetitionDeleteState {
  hostedCompetitionDeleteStatus: StatusEnum;
}

export interface IHostedCompetitionDelete {
  teamId: number;
  hostedCompetitionId: number;
}

const initialState: IHostedCompetitionDeleteState = {
  hostedCompetitionDeleteStatus: StatusEnum.Idle,
};

export const hostedCompetitionDelete = createAsyncThunk(
  "manage/hostedCompetitionDelete",
  async (options: IHostedCompetitionDelete, thunkAPI) => {
    try {
      const hostedCompetitionDeleteResponse = await manageFootballTeamService.removeHostedCompetition(
        options.teamId,
        options.hostedCompetitionId
      );
      return hostedCompetitionDeleteResponse;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const hostedCompetitionDeleteSlice = createSlice({
  name: "hostedCompetitionDelete",
  initialState: initialState,
  reducers: {
    cleanUpHostedCompetitionDelete(state) {
      state.hostedCompetitionDeleteStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(hostedCompetitionDelete.pending, (state) => {
        state.hostedCompetitionDeleteStatus = StatusEnum.Loading;
      })
      .addCase(hostedCompetitionDelete.fulfilled, (state, action) => {
        state.hostedCompetitionDeleteStatus = StatusEnum.Succeeded;
      })
      .addCase(hostedCompetitionDelete.rejected, (state) => {
        state.hostedCompetitionDeleteStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpHostedCompetitionDelete } = hostedCompetitionDeleteSlice.actions;
export default hostedCompetitionDeleteSlice.reducer;
